import {Requestor} from 'hegyd/core/resources/assets/js/utils/Requestor.js'

export default class GenerateBcpCode extends HTMLDivElement {
    constructor() {
        super();
        this.bcpCodeInput = this.querySelector('#bcp_code_input');
    }

    connectedCallback() {
        window.addEventListener('load', () => {
            this.generateCode();
        });
    }

    generateCode()
    {
        setTimeout(() => {
            if (this.bcpCodeInput.value === "") {
                const requestor = new Requestor();

                requestor.sendRequest(this.dataset.route, 'POST', {}, (data) => {
                    this.bcpCodeInput.value = data;
                });
            }
        }, 100);
    }
}
